import React from "react";
import { useMalware } from "../../context/Dashboard/contextMalware";
import { useThemeMode } from "../../context/contextTheme";
import OnLoadUrl from "./scan/url";
import OnLoadFile from "./scan/file";
import { useDesign } from "../../context/contextDesign";

const ScanView = () => {
  const { theme } = useThemeMode();
  const { bHeightVal } = useDesign();
  const { activeTab, setActiveView } = useMalware();

  return (
    <div className="container py-4" style={{ height: bHeightVal }}>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
           <button 
            className="btn btn-sm btn-outline-secondary mb-2"
            onClick={() => setActiveView("GRAPH")}
           >
             <i className="bi bi-arrow-left me-2"></i>Back to History
           </button>
           <h3 className="fw-bold" style={{ color: theme.textColor }}>Scan Analysis</h3>
        </div>
      </div>
      
      <div className="card shadow-sm rounded-4 border-0 p-4" style={{ backgroundColor: theme.background }}>
        {activeTab === 0 ? <OnLoadUrl /> : <OnLoadFile />}
      </div>
    </div>
  );
};

export default ScanView;
